import styled from "styled-components";

const ErrorPage = () => {
  return (
    <ErrorDiv>
      <h1>Page 404</h1>
    </ErrorDiv>
  );
};
const ErrorDiv = styled.div`
  background-color: var(--black);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  h1 {
    font-size: 150px;
  }
  @media screen and (min-width: 992px) {
    /* start of desktop styles */
  }
  @media screen and (max-width: 991px) {
    /* start of phone and medium tablet styles */
    h1 {
      font-size: 70px;
    }
  }
`;
export default ErrorPage;
